import { render, staticRenderFns } from "./NewUserLogin.vue?vue&type=template&id=21803056&scoped=true"
import script from "./NewUserLogin.vue?vue&type=script&lang=js"
export * from "./NewUserLogin.vue?vue&type=script&lang=js"
import style0 from "./NewUserLogin.vue?vue&type=style&index=0&id=21803056&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21803056",
  null
  
)

export default component.exports